import React from 'react';
import Card from '../../../../Presentation/components/ui/Card';
import {StoreStatistics} from '../../models/store.model';

interface StoresStatisticsSummaryProps {
  statistics: StoreStatistics | null;
}

export const StoresStatisticsSummary: React.FC<StoresStatisticsSummaryProps> = ({
  statistics
}) => {
  const activePercentage = statistics?.activePercentage || 0;
  const pendingPercentage = statistics?.totalStores && statistics.totalStores > 0
    ? Math.round((statistics.pendingPaymentStores / statistics.totalStores) * 100)
    : 0;

  return (
    <Card className="p-6">
      <h3 className="text-lg font-bold text-gray-900 mb-4">ملخص سريع</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="text-center p-4 bg-green-50 rounded-lg">
          <p className="text-3xl font-bold text-green-600">
            {activePercentage}%
          </p>
          <p className="text-sm text-gray-600">نسبة المتاجر النشطة</p>
        </div>

        <div className="text-center p-4 bg-orange-50 rounded-lg">
          <p className="text-3xl font-bold text-orange-600">
            {pendingPercentage}%
          </p>
          <p className="text-sm text-gray-600">نسبة المتاجر المعلقة</p>
        </div>
      </div>
    </Card>
  );
};
